import { pageUrl } from '../../appProperties';

const EmailVerificationOptions = {
  url: `${pageUrl}/verified`,
  handleCodeInApp: true,
}

export default EmailVerificationOptions;
